export const DiscordMessageComponentType = {
    ActionRow    : 1,
    Button       : 2,
    StringSelect : 3,
    TextInput    : 4,
    UserSelect   : 5,
    RoleSelect   : 6,
    MentionableSelect: 7,
    ChannelSelect: 8,
    Section      : 9,
    TextDisplay  : 10,
    Thumbnail    : 11,
    MediaGallery : 12,
    File         : 13,
    Separator    : 14,
    Container    : 17,
} as const;

export const DiscordButtonStyle = {
    Primary : 1,
    Success : 3,
    Danger  : 4,
    Link    : 5,
} as const;

export const DiscordSeparatorSpacing = {
    Small : 1,
    Large : 2,
} as const;

export const DiscordDefaultAvatarUrl = "https://cdn.discordapp.com/embed/avatars/0.png";
